// src/hybridApp/guards/HybridRouteGuard.js
import React from "react";
import { Redirect } from "react-router-dom";
import { isReactNativeWebView } from "../helpers";

/**
 * Guard component for Hybrid App routes.
 * Prevents normal browser users from accessing /hybrid-app/* pages.
 */
const HybridRouteGuard = ({ component: Component, ...rest }) => {
    const isHybrid = isReactNativeWebView();
    const path = window.location.pathname;
    
    // ALWAYS ALLOW /hybrid-bridge (NO GUARD)
    if (path === "/hybrid-bridge") {
        return <Component {...rest} />;
    }

    // Protect all other hybrid routes
    if (!isHybrid) {
        console.warn(
            "[HybridRouteGuard] Unauthorized access attempt to hybrid route:",
            path
        );
        return <Redirect to="/" />;
    }

    // Allowed
    return <Component {...rest} />;
};

export default HybridRouteGuard;
